import { render } from "./GoodForm.vue?vue&type=template&id=1a533d66&scoped=true"
import script from "./GoodForm.vue?vue&type=script&lang=js"
export * from "./GoodForm.vue?vue&type=script&lang=js"

import "./GoodForm.vue?vue&type=style&index=0&id=1a533d66&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a533d66"]])

export default __exports__